module.exports = __webpack_public_path__ + "img/upload-cloud-01.1f3bdd9a.svg";